import Layout from '@/page/layout'
// import fun
const _import = require('../_import')
// scope rent
const scope = 'privilegeManagement'

export default {
  path: '/privilegeManagement',
  name: 'privilegeManagement',
  component: Layout,
  redirect: '/privilegeManagement/staff',
  meta: {title: '权限管理', icon: ''},
  children: [{
    path: 'staff',
    name: 'staff',
    component: _import(`${scope}/staff`),
    meta: {title: '员工管理', icon: ''}
  },
  {
    path: 'role',
    name: 'role',
    component: _import(`${scope}/role`),
    meta: {title: '角色管理', icon: ''}
  },
  {
    path: 'staff-unit',
    name: 'staff-unit',
    component: _import(`${scope}/staff-unit`),
  },
]

}



// WEBPACK FOOTER //
// ./src/router/modules/privilegeManagement.js